




































import Vue, { PropOptions } from 'vue'
import { Announcement } from '@/common/types/announcements'

const announcementTypes: string[] = ['emergency', 'alert', 'info']

export default Vue.extend({
  props: {
    announcements: {
      type: Array,
      required: true
    } as PropOptions<Announcement[]>
  },
  computed: {
    announcementTypes() {
      return announcementTypes
    },
    isTopPage(): boolean {
      return window.location.pathname === '/'
    }
  },
  methods: {
    filterAnnouncements(announcementType: string): Announcement[] {
      return this.announcements.filter(announcement => {
        return announcement.announcement_type === announcementType
      })
    },
    cssClassSelector(announcementType: string): string {
      return `sw-Flash_MessageBox-${announcementType}`
    }
  }
})
